
export default {
	meta: state => state.meta,
	parts: state => state.parts,
	params: (state, getters, rootState) => {
		const departmentId = rootState?.Auth?.user?.selectedDepartmentId
		const vehicleType = rootState?.Auth?.user?.selectedVehicleType
		const cacheKey = `${departmentId}:${vehicleType}`
		return (departmentId && state.tpParamsByDepartment[cacheKey]) || state.params
	},
	loading: state => state.loading,
	searchFilters: state => state.searchFilters,
	manufacturerModels: state => state.manufacturerModels,
	modelModifications: state => state.modelModifications,
	modificationEngines: state => state.modificationEngines,
	departmentLocations: state => state.departmentLocations,
	currentPart: state => state.currentPart,
	picturesCallback: state => state.picturesCallback,
	selectedParts: state => state.selectedParts,
	partsStatistics: state => state.partsStatistics,
	partParams: state => state.partParams,
	logs: state => state.logs,
	showing: state => state.showing,
	wheelSpecifications: state => state.wheelSpecifications && Object.fromEntries(
		Object.entries(state.wheelSpecifications).map(([key, value]) => {
			let targetValue = value
			if (Array.isArray(targetValue)) {
				targetValue = [...targetValue].sort((a, b) => {
					return a.name.localeCompare(b.name, undefined, {
						numeric: true,
						sensitivity: 'base'
					})
				})
			}
			return [key, targetValue]
		})
	),
	partWheelSpecifications: state => state.partWheelSpecifications
}

